import Splide from '@splidejs/splide';

// Categories Grid
(() => {
  const categoryGrid = document.querySelector('.category-section-2');
  if (!categoryGrid) return;

  categoryGrid.querySelectorAll('.quicklinks > ul > li').forEach((item) => {
    const topAnchor = item.querySelector('a');
    if (!topAnchor) return;
    const cloneAnchor = topAnchor.cloneNode(true);
    cloneAnchor.classList.add('shop-now');
    cloneAnchor.textContent = 'Shop Now';
    if (!topAnchor.nextElementSibling) return;
    topAnchor.nextElementSibling.append(cloneAnchor);

    const catBgImage = item.querySelector('.cat-bg-img img');
    if (!catBgImage) return;
    const imageWrapper = document.createElement('div');
    imageWrapper.classList.add('image-wrapper');
    imageWrapper.innerHTML = `<img src="${catBgImage.src}" alt="" aria-hidden="true" role="presentation">`;
    topAnchor.before(imageWrapper);
  });
})();

(() => {
  const categorySource = document.querySelector('.category-section-2');
  if (!categorySource) return;

  const slider = document.createElement('div');
  slider.classList.add('category-section-2__slider', 'splide');
  categorySource.appendChild(slider);
  const sliderTrack = document.createElement('div');
  sliderTrack.classList.add('splide__track');
  slider.appendChild(sliderTrack);
  const sliderList = document.createElement('div');
  sliderList.classList.add('splide__list');
  sliderTrack.appendChild(sliderList);

  const categories = categorySource.querySelectorAll('.hasSubmenus > li');
  categories.forEach((category) => {
    const sliderSlide = document.createElement('div');
    sliderSlide.classList.add('splide__slide');
    sliderSlide.innerHTML = category.innerHTML;
    sliderList.appendChild(sliderSlide);
  });

  categorySource.querySelector('.quicklinks').insertAdjacentElement('beforeend', slider);

  const cardAmount = slider.querySelectorAll('.splide__slide').length;
  const splide = new Splide(slider, {
    type: 'slider',
    perPage: 6,
    perMove: 1,
    height: 350,
    gap: 10,
    pagination: cardAmount > 6,
    arrows: false,
    drag: cardAmount > 6,
    breakpoints: {
      1862: {
        perPage: 5,
        drag: cardAmount > 5,
        pagination: cardAmount > 5,
      },
      1574: {
        perPage: 4,
        drag: cardAmount > 4,
        pagination: cardAmount > 4,
      },
      1130: {
        perPage: 3,
        drag: cardAmount > 3,
        pagination: cardAmount > 3,
      },
      850: {
        perPage: 2,
        drag: cardAmount > 2,
        pagination: cardAmount > 2,
      },
      600: {
        perPage: 1,
        drag: cardAmount > 1,
        pagination: cardAmount > 1,
      },
    },
  });
  splide.mount();
})();
